import { render, staticRenderFns } from "./FrontLayout.vue?vue&type=template&id=efdb4e5e&scoped=true"
import script from "./FrontLayout.vue?vue&type=script&lang=js"
export * from "./FrontLayout.vue?vue&type=script&lang=js"
import style0 from "./FrontLayout.vue?vue&type=style&index=0&id=efdb4e5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efdb4e5e",
  null
  
)

export default component.exports